var _g, _g2, _g3, _g4, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntroBlurLightTheme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1337 752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#intro-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#286CF6",
    fillOpacity: 0.7,
    d: "m323.822 440.481 770.628-215.223 61.6 146.833-476.647 117.137-355.581-48.747Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#intro-b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C3A6FF",
    fillOpacity: 0.5,
    d: "M651.034 354.664 1065.13 200 897.31 379.959 250.563 533.99l400.471-179.326Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#intro-c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C3A6FF",
    d: "M742.578 377.116 530.85 264.086l21.8 150.699 474.16 141.52-284.232-179.189Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#intro-d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00F6FF",
    fillOpacity: 0.8,
    d: "m552.758 501.704-45.984 78.719-335.553-19.258 891.989-277.477-184.314 93.293-326.138 124.723Z"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#intro-e)",
    opacity: 0.5,
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#intro-f)",
    fillOpacity: 0.8,
    d: "M623.276 526.093c-65.326 15.851-145.544-18.486-179.171-76.692-33.628-58.206-7.931-118.241 57.396-134.091l88.009-21.355c65.326-15.85 145.544 18.486 179.171 76.692 33.627 58.207 7.93 118.242-57.396 134.092l-88.009 21.354Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "intro-a",
    width: 1192.23,
    height: 623.97,
    x: 143.822,
    y: 45.258,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2713_53635",
    stdDeviation: 90
  })), /*#__PURE__*/React.createElement("filter", {
    id: "intro-b",
    width: 1214.57,
    height: 733.99,
    x: 50.563,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2713_53635",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "intro-c",
    width: 837.957,
    height: 634.219,
    x: 359.85,
    y: 93.086,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2713_53635",
    stdDeviation: 85.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "intro-d",
    width: 1233.99,
    height: 638.734,
    x: 0.221,
    y: 112.688,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2713_53635",
    stdDeviation: 85.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "intro-e",
    width: 696.135,
    height: 581.868,
    x: 258.326,
    y: 119.09,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2713_53635",
    stdDeviation: 85.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "intro-f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(115.40256 -75.62639 69.48968 106.0382 653.279 446.274)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003EBC",
    stopOpacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroBlurLightTheme);
export default __webpack_public_path__ + "2ebc459031d35c429876ff103b2ec14d.svg";
export { ForwardRef as ReactComponent };